/**
 * Mirrors the server's `InterviewKind` value for value. Never typed by the user: it is decided by
 * which of the three entry points was chosen (record a conversation, dictate notes, enter a text),
 * and carried from there onward (`newInterviewDraftSignal`, `CreateInterview.toJSON()`,
 * `CreateTextInterview.toJSON()`) — never a form field. The server is the sole source of `label`,
 * delivered in French as `{ value, label }` on every `Interview` this value appears on
 * (`InterviewView.kind`).
 */
export enum InterviewKind {
	CONVERSATION = 'conversation',
	NOTES = 'notes',
	TEXT = 'text',
}
